import { a } from '../chunk-VWBRSNY4.mjs';
export { b as middleware } from '../chunk-VWBRSNY4.mjs';
import { b } from '../chunk-AUGNQZOJ.mjs';
import '../chunk-WCWZMNBD.mjs';

var n={browser:b,server:a};

export { n as init };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map